import type { OrderSheetDetailDto } from "@repo/types";
import { useQuery } from "@tanstack/react-query";
import { getOrderSheetDetail } from "../api/orderSheetApi";

export const useOrderSheetDetail = (id: number | null) => {
  return useQuery<OrderSheetDetailDto>({
    queryKey: ["orderSheetDetail", id],
    queryFn: () => {
      if (id === null) {
        throw new Error("주문서 ID가 없습니다.");
      }
      return getOrderSheetDetail(id);
    },
    enabled: id !== null,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};